(function () {
  const trackedEventIds = new Set();
  let latestCart = null;

  function getCurrency() {
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
  }

  function centsToMoney(value) {
    const number = Number(value || 0);
    return Number.isFinite(number) ? number / 100 : 0;
  }

  function buildPayload(detail) {
    const item = detail.cartData || {};
    const variantId = String(detail.productVariantId || item.variant_id || item.id || '');
    const quantity = Number(item.quantity || detail.quantity || 1);
    const value = centsToMoney(item.final_line_price || item.line_price || item.price * quantity);
    const eventId = `mb_atc_${variantId || 'unknown'}_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;

    return {
      eventId,
      currency: getCurrency(),
      value,
      quantity,
      variantId,
      productId: item.product_id ? String(item.product_id) : '',
      productTitle: item.product_title || item.title || '',
      variantTitle: item.variant_title || '',
      sku: item.sku || '',
      url: window.location.href,
    };
  }

  /*
  function getCookie(name) {
    const prefix = `${name}=`;
    const cookie = document.cookie.split('; ').find((item) => item.indexOf(prefix) === 0);
    return cookie ? decodeURIComponent(cookie.slice(prefix.length)) : '';
  }

  function capiBasePayload(payload) {
    return {
      event_id: payload.eventId,
      event_source_url: payload.url || window.location.href,
      currency: payload.currency || getCurrency(),
      value: Number(payload.value || 0),
      content_ids: [payload.variantId || payload.productId || payload.sku].filter(Boolean),
      content_name: payload.productTitle || document.title,
      contents: [
        {
          id: payload.variantId || payload.productId || payload.sku || '',
          quantity: Number(payload.quantity || 1),
          item_price: Number(payload.quantity ? payload.value / payload.quantity : payload.value || 0),
        },
      ],
      fbp: getCookie('_fbp'),
      fbc: getCookie('_fbc'),
    };
  }

  function sendMetaCapi(eventName, payload) {
    const endpoint = window.MB_ADS_OPS_EVENTS_URL;
    if (!endpoint) return;

    const body = JSON.stringify({
      event_name: eventName,
      ...capiBasePayload(payload),
    });

    if (navigator.sendBeacon) {
      const blob = new Blob([body], { type: 'application/json' });
      if (navigator.sendBeacon(endpoint, blob)) return;
    }

    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body,
      keepalive: true,
      credentials: 'omit',
    }).catch(() => {});
  }
  */

  function hasLegacyKlaviyoAddedToCartSnippet() {
    return Array.from(document.scripts).some((script) => {
      const content = script.textContent || '';
      return content.includes("_learnq.push(['track', 'Added to Cart'") && content.includes('klAjax');
    });
  }

  function trackKlaviyo(payload) {
    if (hasLegacyKlaviyoAddedToCartSnippet()) return;
    const learnq = window._learnq;
    if (!Array.isArray(learnq)) return;

    learnq.push([
      'track',
      'Added to Cart',
      {
        $value: payload.value,
        value: payload.value,
        currency: payload.currency,
        product_id: payload.productId,
        variant_id: payload.variantId,
        sku: payload.sku,
        product_name: payload.productTitle,
        variant_name: payload.variantTitle,
        quantity: payload.quantity,
        url: payload.url,
        event_id: payload.eventId,
      },
    ]);
  }

  function trackDataLayer(payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'add_to_cart',
      mb_event_id: payload.eventId,
      ecommerce: {
        currency: payload.currency,
        value: payload.value,
        items: [
          {
            item_id: payload.variantId || payload.sku || payload.productId,
            item_name: payload.productTitle,
            item_variant: payload.variantTitle,
            item_sku: payload.sku,
            quantity: payload.quantity,
            price: payload.quantity ? payload.value / payload.quantity : payload.value,
          },
        ],
      },
    });
  }

  function trackGoogle(payload) {
    if (typeof window.gtag !== 'function') return;

    window.gtag('event', 'add_to_cart', {
      currency: payload.currency,
      value: payload.value,
      event_id: payload.eventId,
      items: [
        {
          item_id: payload.variantId || payload.sku || payload.productId,
          item_name: payload.productTitle,
          item_variant: payload.variantTitle,
          quantity: payload.quantity,
          price: payload.quantity ? payload.value / payload.quantity : payload.value,
        },
      ],
    });
  }

  function trackMeta(payload) {
    if (typeof window.fbq !== 'function') return;

    window.fbq(
      'track',
      'AddToCart',
      {
        content_ids: [payload.variantId || payload.productId].filter(Boolean),
        content_name: payload.productTitle,
        content_type: 'product',
        currency: payload.currency,
        value: payload.value,
      },
      { eventID: payload.eventId }
    );
  }

  function cartPayload(cart) {
    const items = cart && Array.isArray(cart.items) ? cart.items : [];
    const firstItem = items[0] || {};
    return {
      eventId: `mb_checkout_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
      currency: getCurrency(),
      value: centsToMoney(cart ? cart.total_price : 0),
      quantity: items.reduce((total, item) => total + Number(item.quantity || 0), 0) || 1,
      variantId: firstItem.variant_id ? String(firstItem.variant_id) : '',
      productId: firstItem.product_id ? String(firstItem.product_id) : '',
      productTitle: firstItem.product_title || firstItem.title || 'Cart',
      variantTitle: firstItem.variant_title || '',
      sku: firstItem.sku || '',
      url: window.location.href,
    };
  }

  function refreshCartSnapshot() {
    if (!window.routes || !window.routes.cart_url) return;
    fetch(`${window.routes.cart_url}.js`, { credentials: 'same-origin' })
      .then((response) => (response.ok ? response.json() : null))
      .then((cart) => {
        if (cart) latestCart = cart;
      })
      .catch(() => {});
  }

  function trackViewContent() {
    if (!window.location.pathname.includes('/products/')) return;
    /*
    const eventId = `mb_view_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
    sendMetaCapi('ViewContent', {
      eventId,
      currency: getCurrency(),
      value: 0,
      quantity: 1,
      productTitle: document.title,
      url: window.location.href,
    });
    */
  }

  function trackInitiateCheckout() {
    /*
    const payload = cartPayload(latestCart || {});
    sendMetaCapi('InitiateCheckout', payload);
    */
  }

  window.addEventListener('mb:add_to_cart', (event) => {
    const payload = buildPayload(event.detail || {});
    if (trackedEventIds.has(payload.eventId)) return;
    trackedEventIds.add(payload.eventId);
    if (event.detail && event.detail.cartData) latestCart = event.detail.cartData;

    // trackDataLayer(payload);
    // trackGoogle(payload);
    // trackMeta(payload);
    trackKlaviyo(payload);
    // sendMetaCapi('AddToCart', payload);
    refreshCartSnapshot();
  });

  document.addEventListener(
    'click',
    (event) => {
      const target = event.target && event.target.closest ? event.target.closest('[name="checkout"], a[href*="/checkout"]') : null;
      if (target) trackInitiateCheckout();
    },
    true
  );

  refreshCartSnapshot();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', trackViewContent, { once: true });
  } else {
    trackViewContent();
  }
})();
